export default __webpack_public_path__ + "static/media/FSKoopman-ExtraBold.3aba5d1b.woff";